import { frontendURL } from '../../../helper/URLHelper';

const VoiceHome = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/voice'),
      name: 'voice_teaser',
      component: VoiceHome,
      meta: {
        title: 'SIDEBAR.VOICE',
        voiceSoftphonePage: true,
        permissions: ['administrator', 'agent', 'supervisor', 'cx_engineer'],
      },
    },
  ],
};
